import { atom } from 'jotai';

export const numberOfEventsForFeedbackAtom = atom<number>(0);
